import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import rank1 from "../Assets/images/rank1.png";
import rank2 from "../Assets/images/rank2.png";
import rank3 from "../Assets/images/rank3.png";
import axios from "axios";
import apiClient from "../apiClient";

const Leaderboard = () => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [first, setFirst] = useState({
    name: null,
    uuid: null,
    email: null,
    avatar: null,
    group: null,
    points: 0,
    rank: null,
  });
  const [second, setSecond] = useState({
    name: null,
    uuid: null,
    email: null,
    avatar: null,
    group: null,
    points: 0,
    rank: null,
  });
  const [third, setThird] = useState({
    name: null,
    uuid: null,
    email: null,
    avatar: null,
    group: null,
    points: 0,
    rank: null,
  });
  const [leaders, setLeaders] = useState([]);
  const [ownRank, setOwnRank] = useState({
    name: null,
    uuid: null,
    email: null,
    avatar: null,
    group: null,
    points: 0,
    rank: null,
  });
  const [loading, setLoading] = useState(true);

  const getLeaderBoardUsersList = async () => {
    try {
      setLoading(true);

      let data = await apiClient.get(`${configData.config.API_URL}/api/dashboard/leaderboard`);

      // const { data } = await axios.get(`${configData.config.API_URL}/api/dashboard/leaderboard`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });


      let response = data;
      let firstRank = response.list.find((f) => f.rank === 1);
      let secondRank = response.list.find((f) => f.rank === 2);
      let thirdRank = response.list.find((f) => f.rank === 3);
      let leader = response.list.slice(3);

      firstRank && setFirst(firstRank);
      secondRank && setSecond(secondRank);
      thirdRank && setThird(thirdRank);
      leader.length > 0 && setLeaders(leader);
      response.ownRank && setOwnRank(response.ownRank);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLeaderBoardUsersList();
  }, []);

  return (
    <div className="container-fluid bg-grey-main leaderboard dashboard p-3 pt-2 pb-0">
      <div className="row leaderboard">
        <div className="col-md-12">
          <div className="toprank mt-1 px-3">
            <div className="row align-items-end pt-4">
              {/* Second Rank */}
              <div className="col-lg-4">
                {second.uuid && (
                  <div className="topleader stleader rank2">
                    <p className="rank">
                      {" "}
                      <img src={rank2} referrerPolicy={"no-referrer"} />{" "}
                    </p>
                    {!loading ? (
                      <>
                        {second?.avatar ? (
                          <img
                            className="mauserlead"
                            src={second.avatar}
                            alt={second?.name}
                            referrerPolicy={"no-referrer"}
                          />
                        ) : (
                          <span className="user-lead-ini">
                            {second?.name
                              ? second?.name
                                .split(" ")
                                .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                .join("")
                              : ""}
                          </span>
                        )}
                      </>
                    ) : (
                      <Skeleton count={1} circle height="55px" width="55px" />
                    )}
                    <div>
                      <p className="name"> {!loading ? <> {second?.name} </> : <Skeleton width="5vw" />}</p>
                      <p className="email"> {!loading ? <> {second?.email} </> : <Skeleton width="5vw" />} </p>
                      <hr />
                      <p className="gname">{!loading ? <> {second?.group} </> : <Skeleton width="5vw" />}</p>
                      <p className="errors">
                        <span>{!loading ? <> Rewards : {second?.points} </> : <Skeleton width="5vw" />}</span>{" "}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* First rank */}
              <div className="col-lg-4">
                {first.uuid && (
                  <div className="topleader stleader rank1">
                    <p className="rank">
                      <img src={rank1} referrerPolicy={"no-referrer"} />{" "}
                    </p>
                    {!loading ? (
                      <>
                        {" "}
                        {first?.avatar ? (
                          <img
                            className="mauserlead"
                            src={first.avatar}
                            alt={first.name}
                            referrerPolicy={"no-referrer"}
                          />
                        ) : (
                          <span className="user-lead-ini">
                            {first?.name
                              ? first?.name
                                .split(" ")
                                .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                .join("")
                              : ""}
                          </span>
                        )}
                      </>
                    ) : (
                      <Skeleton count={1} circle height="55px" width="55px" />
                    )}
                    <div>
                      <p className="name"> {!loading ? <> {first?.name} </> : <Skeleton width="5vw" />}</p>
                      <p className="email"> {!loading ? <> {first?.email} </> : <Skeleton width="5vw" />} </p>
                      <hr />
                      <p className="gname">{!loading ? <> {first?.group} </> : <Skeleton width="5vw" />}</p>
                      <p className="errors">
                        <span>{!loading ? <> Rewards : {first?.points} </> : <Skeleton width="5vw" />}</span>{" "}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Third Rank */}
              <div className="col-lg-4">
                {third.uuid && (
                  <div className="topleader stleader rank3">
                    <p className="rank">
                      <img src={rank3} referrerPolicy={"no-referrer"} />{" "}
                    </p>
                    {!loading ? (
                      <>
                        {third?.avatar ? (
                          <img
                            className="mauserlead"
                            src={third.avatar}
                            alt={third.name}
                            referrerPolicy={"no-referrer"}
                          />
                        ) : (
                          <span className="user-lead-ini">
                            {third.name
                              ? third.name
                                .split(" ")
                                .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                .join("")
                              : ""}
                          </span>
                        )}{" "}
                      </>
                    ) : (
                      <Skeleton count={1} circle height="55px" width="55px" />
                    )}
                    <div>
                      <p className="name"> {!loading ? <> {third.name} </> : <Skeleton width="5vw" />}</p>
                      <p className="email"> {!loading ? <> {third.email} </> : <Skeleton width="5vw" />} </p>
                      <hr />
                      <p className="gname">{!loading ? <> {third.group} </> : <Skeleton width="5vw" />}</p>
                      <p className="errors">
                        <span>{!loading ? <> Rewards : {third.points} </> : <Skeleton width="5vw" />}</span>{" "}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 px-4">
          <div className="table-responsive workflowtb stickyhead reports">
            <table className="table align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Rank</th>
                  <th className="text-start">Name</th>
                  <th>Groups</th>
                  <th>Rewards</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ background: "#ffb5b7" }}>
                    {" "}
                    {loading ? <Skeleton width="2vw" /> : <> {ownRank.rank} </>}
                  </td>
                  <td style={{ background: "#ffb5b7" }}>
                    <div className="d-flex gap-2 align-items-center justify-content-start namewithmail">
                      {!loading ? (
                        <>
                          {ownRank.avatar ? (
                            <>
                              <img src={ownRank.avatar} alt="avatar" referrerPolicy={"no-referrer"} />
                            </>
                          ) : ownRank?.name ? (
                            <span className="ranked-ini">
                              {ownRank?.name
                                ?.split(" ")
                                ?.map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                .join("")}
                            </span>
                          ) : null}
                        </>
                      ) : (
                        <Skeleton count={1} circle height="35px" width="35px" />
                      )}
                      <div>
                        <p>{loading ? <Skeleton width="15vw" /> : <> {ownRank.name} </>}</p>
                        <p>{loading ? <Skeleton width="15vw" /> : <> {ownRank.email} </>} </p>
                      </div>
                    </div>
                  </td>
                  <td style={{ background: "#ffb5b7" }}>
                    {" "}
                    {loading ? <Skeleton width="5vw" /> : <> {ownRank.group} </>}{" "}
                  </td>
                  <td style={{ background: "#ffb5b7" }}>
                    {" "}
                    {loading ? <Skeleton width="2vw" /> : <> {ownRank.points} </>}{" "}
                  </td>
                </tr>

                {loading ? (
                  <tr>
                    <td>
                      <Skeleton width="5vw" />
                    </td>
                    <td>
                      <div className="d-flex gap-2 align-items-center justify-content-start namewithmail">
                        <Skeleton count={1} circle height="35px" width="35px" />
                        <div>
                          <p>
                            <Skeleton width="15vw" />
                          </p>
                          <p>
                            <Skeleton width="15vw" />
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <Skeleton width="5vw" />
                    </td>
                    <td>
                      <Skeleton width="2vw" />
                    </td>
                  </tr>
                ) : (
                  leaders.map((leader, i) => (
                    <tr key={i}>
                      <td>{leader.rank}</td>
                      <td>
                        <div className="d-flex gap-2 align-items-center justify-content-start namewithmail">
                          {leader.avatar ? (
                            <img src={leader.avatar} alt="avatar" referrerPolicy={"no-referrer"} />
                          ) : (
                            <span className="ranked-ini">
                              {leader.name
                                .split(" ")
                                .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                .join("")}
                            </span>
                          )}
                          <div>
                            <p>{leader.name}</p>
                            <p>{leader.email}</p>
                          </div>
                        </div>
                      </td>
                      <td>{leader.group}</td>
                      <td>{leader.points}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
